import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

export function ConfirmExtraction({
  selectedCountry,
  selectedFirstLevels,
  selectedSecondLevels,
  firstLevelType,
  secondLevelType,
  completedExtractions,
  onConfirm,
}) {
  const isExtracted = (name) =>
    completedExtractions.some(
      (c) => c.country === selectedCountry && c.first_level === name
    );

  const multiSelect = selectedFirstLevels.length > 1;

  return (
    <Card className="bg-slate-900/50 border-slate-800" data-testid="confirm-extraction-card">
      <CardHeader>
        <CardTitle>Confirm Extraction</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="bg-slate-800/50 rounded-lg p-4 mb-4 space-y-2">
          <div className="flex justify-between">
            <span className="text-slate-400">Country:</span>
            <span data-testid="confirm-country">{selectedCountry}</span>
          </div>

          {!multiSelect ? (
            <div className="flex justify-between">
              <span className="text-slate-400">{firstLevelType}:</span>
              <span data-testid="confirm-first-level">{selectedFirstLevels[0]?.name}</span>
            </div>
          ) : (
            <div>
              <div className="flex justify-between mb-1">
                <span className="text-slate-400">{firstLevelType}s:</span>
                <span data-testid="confirm-first-level">{selectedFirstLevels.length} selected</span>
              </div>
              <div className="flex flex-wrap gap-1 mt-1">
                {selectedFirstLevels.map((s) => {
                  const name = s.name || s;
                  const extracted = isExtracted(name);
                  return (
                    <Badge
                      key={`cf-${name}`}
                      variant="outline"
                      className={`text-xs ${extracted ? "border-emerald-500/40 text-emerald-400" : "border-slate-600"}`}
                    >
                      {extracted && (
                        <svg className="w-2.5 h-2.5 mr-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" />
                        </svg>
                      )}
                      {name}
                    </Badge>
                  );
                })}
              </div>
            </div>
          )}

          {selectedSecondLevels.length > 0 && (
            <div className="flex justify-between">
              <span className="text-slate-400">{secondLevelType}s:</span>
              <span data-testid="confirm-second-levels">{selectedSecondLevels.length} selected</span>
            </div>
          )}
        </div>
        <Button data-testid="btn-confirm-extract" onClick={onConfirm} className="w-full bg-emerald-600 hover:bg-emerald-500">
          Confirm & Start Extraction{multiSelect ? ` (${selectedFirstLevels.length} regions)` : ""}
        </Button>
      </CardContent>
    </Card>
  );
}
